(() => {
  const service = document.querySelector('[data-service-key="handover-support"]');
  if (!service) return;

  const placeholder = '';

  const enhanceTextarea = () => {
    const textareas = Array.from(service.querySelectorAll(
      '.mw-option[data-bcu-role="step-3"] textarea, .bcu-service-step[data-bcu-step="step-3"] textarea',
    ));

    textareas.forEach((textarea, index) => {
      if (textarea.dataset.bcuHandoverEnhanced === 'true') return;

      textarea.dataset.bcuHandoverEnhanced = 'true';
      textarea.maxLength = 500;
      textarea.placeholder = placeholder;

      const option = textarea.closest('.mw-option');
      const icon = option?.querySelector('[data-mw-tooltip]');
      if (option?.dataset.bcuProxy === 'true' && icon) {
        const helpId = `${textarea.id}-help`;
        const button = icon;
        button.removeAttribute('data-mw-tooltip');
        button.removeAttribute('data-mw-tooltip-placement');
        button.classList.add('bcu-handover-help-trigger');
        button.tabIndex = 0;
        button.setAttribute('role', 'button');
        button.setAttribute('aria-label', 'Hinweise zur Situationsbeschreibung');
        button.setAttribute('aria-describedby', helpId);
        const help = document.createElement('div');
        help.id = helpId;
        help.className = 'bcu-handover-help';
        help.setAttribute('role', 'tooltip');
        help.hidden = true;
        help.innerHTML = '<p>Beschreiben Sie Ihre aktuelle Situation, zum Beispiel:</p><ul><li>Unstimmigkeiten mit der Verwaltung</li><li>offene Mängel</li><li>Fragen zu Übergabeprotokoll, Kaution, Abrechnung oder Kündigung</li><li>Konflikte mit Mieterschaft oder Eigentümer</li></ul>';
        option.append(help);
        let hideTimer;
        const hide = () => { help.hidden = true; };
        const show = () => {
          window.clearTimeout(hideTimer);
          const rect = button.getBoundingClientRect();
          help.hidden = false;
          const left = Math.max(12, Math.min(rect.left, window.innerWidth - help.offsetWidth - 12));
          const top = rect.bottom + 6;
          help.style.left = `${left}px`;
          help.style.top = `${top + help.offsetHeight > window.innerHeight - 12 ? Math.max(12, rect.top - help.offsetHeight - 6) : top}px`;
        };
        const deferHide = () => { hideTimer = window.setTimeout(hide, 120); };
        button.addEventListener('mouseenter', show);
        button.addEventListener('mouseleave', deferHide);
        button.addEventListener('focus', show);
        button.addEventListener('blur', deferHide);
        help.addEventListener('mouseenter', () => window.clearTimeout(hideTimer));
        help.addEventListener('mouseleave', deferHide);
        window.addEventListener('scroll', hide, { passive: true });
        button.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
        });
        button.addEventListener('keydown', (event) => {
          if (event.key !== 'Escape') return;
          hide();
        });
      }
      const appCounter = option?.querySelector('.mw-option__helptext:not([data-helptext-type])');
      if (appCounter) {
        const counterId = `BcuHandoverCounter-${index + 1}`;
        appCounter.id = counterId;
        appCounter.classList.add('bcu-handover-character-counter');
        textarea.setAttribute('aria-describedby', counterId);
      }

      const updateCounter = () => {
        if (appCounter) appCounter.textContent = `${textarea.value.length} / 500`;
      };

      option?.querySelectorAll('[data-helptext-type="required"]').forEach((message) => {
        message.textContent = 'Bitte beschreiben Sie kurz Ihre Situation.';
      });
      option?.querySelectorAll('[data-helptext-type="length_range"]').forEach((message) => {
        message.textContent = 'Es sind maximal 500 Zeichen möglich.';
      });

      textarea.addEventListener('input', updateCounter);
      updateCounter();
    });
  };

  enhanceTextarea();
  new MutationObserver(enhanceTextarea).observe(service, { childList: true, subtree: true });
})();
